__turbopack_context__.v({
  "container": "styles-module__LYDhkq__container",
  "qrCodeDynamic": "styles-module__LYDhkq__qrCodeDynamic",
  "qrCodeDynamic--lg": "styles-module__LYDhkq__qrCodeDynamic--lg",
  "qrCodeDynamic--md": "styles-module__LYDhkq__qrCodeDynamic--md",
});
